import { useFiltersContext } from '@openx/components-filters/lib/context/FiltersContext';
import { TopBar } from '@openx/components-table/ChipFilters/TopBar';
import { useTranslation } from 'react-i18next';
import type { AudiencesListFilters } from '../types';

export const AudienceListTopBar = () => {
  const { t } = useTranslation();
  const { onFiltersChange, criteria } = useFiltersContext<AudiencesListFilters>();

  return (
    <TopBar
      filters={criteria.filters as AudiencesListFilters}
      onChange={onFiltersChange}
      searchText={t('Search')}
      useFiltersV2
    />
  );
};
